export class GetSOPricingError extends Error {
  constructor(error) {
    super(error.message);
    this.name = 'GetSOPricingError';
    this.originalError = error;
    this.response = error.response;
  }
}